import { User } from './typeUser';

export interface INetwork {
  id: string;
  name: string;
  chainId: string;
  blockscan_url: string;
  token_symbol: string;
  token_decimals: number;
  confirmations: number;
  from_usd_fee: number;
  to_usd_fee: number;
  type: string;
  is_ordered_track: boolean;
  is_work: boolean;
  timeout_ms: number;
  use_highest_gas: boolean;
  active: boolean;
  life_time_orders: number;
  is_support_eip1559: boolean;
  popularity?: unknown;
  bridge_popularity?: unknown;
  created_at: string;
  updatedAt: string;
  source_position?: unknown;
  destination_position?: unknown;
  blocks_scope_limit?: unknown;
}

export interface IContract {
  id: string;
  address: string;
  type: string;
  network: INetwork;
}

export interface ICurrency {
  id: string;
  symbol: string;
  decimals: number;
  active: boolean;
  deposit_fee: number;
  deposit_aml_fee: number;
  min_deposit: number;
  withdrawal_fee: number;
  withdrawal_aml_fee: number;
  min_withdrawal: number;
  display_precision: number;
  contract?: IContract;
}

export interface ICurrencyExtended extends ICurrency {
  contracts?: Record<string, unknown>;
}

export interface IDeposit {
  id: string;
  type: string;
  amountIn: string;
  amountOut: string | null;
  currency?: ICurrency;
  currencyIn?: ICurrency;
  currencyOut?: ICurrency;
  status: string;
  transactionInHash?: string;
  transactionHash?: string;
  transactionAt?: string;
  transactionFromGasStation?: string | null;
  transactionToGasStationAt?: string | null;
  transactionOutHash?: string | null;
  transactionOutAt?: string | null;
  transactionRefundHash?: string | null;
  transactionRefundedAt?: string | null;
  walletSender?: string;
  walletReceiver?: string;
  completedOrFailedAt?: string | null;
  reasonOfFailure?: string | null;
  createdAt: string;
  updatedAt: string;
  updatedBalanceAt?: string | null;
  processedAt?: string | null;
  amlLog?: {
    id?: string;
    walletAddress?: string;
    transaction?: string;
    responseData?: {
      result?: {
        data?: {
          status?: string;
          riskscore?: number;
        };
      };
      risk_score?: number;
    };
    checkType?: string;
    depositOrderId?: string;
    withdrawOrderId?: string;
    userId?: string;
    createdAt?: string;
    amount?: string;
    currencyId?: string;
    contractId?: string;
  } | null;
  user?: User;
  processedStatus?: string | null;
  fee?: string | null;
}

export interface ICard {
  id: string;
  status: string;
  mask: string;
  card_id: string;
  card_number: string;
  card_epx_month: string;
  card_epx_year: string;
  card_bin: number;
  card_type: string | null;
  account_id: string;
  is_auto_replenished: boolean;
  holder_name: string;
  holder_address: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  user?: User;
}

export type TProcessedByAdmin = {
  id: string;
  login: string;
  role: string;
  telegramId: string | null;
  name: string | null;
};

export interface IDepositExtended extends IDeposit {
  from?: string;
  to?: string;
  amount?: string;
  currency_id?: string;
  sender?: User;
  receiver?: User;
  created_at?: string;
  updated_at?: string;
  card?: ICard;
  cardId?: string;

  // Add missing fields from API schema
  contractIn?: IContract | null;
  contractOut?: IContract | null;
  userId?: string;

  // For fee breakdown (if available)
  amlFee?: string;
  networkFee?: string;

  executedRate?: string;
  rate?: string;

  processedByAdmin?: TProcessedByAdmin;
  refundAddress?: string | null;
  refundTxHash?: string | null;
  processedAt?: string | null;

  tier?: number | null;
  referralPercentage?: string | null;
  swapType?: 'SELL' | 'BUY';
  swapRate?: string | null;
  txType?: 'TOPUP' | 'SWAP';
  sourceTransactionId?: string;
  referral?: User;
  engineRun?: {
    id: string;
    status: EEngineRunStatus;
    path: string[];
    currentStep: number;
    actionType: EEngineActionType;
    reasonOfFailure?: string;
    createdAt: string;
    updatedAt: string;
  };
}

export type SortOrder = 'ASC' | 'DESC';

export type TransactionSortField =
  | 'id'
  | 'type'
  | 'createdAt'
  | 'amountIn'
  | 'status';

export interface SortParams {
  sortBy?: TransactionSortField;
  sortOrder?: SortOrder;
}

export enum EEngineActionType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  SWAP = 'SWAP',
  CARD_ISSUE = 'CARD_ISSUE',
  CARD_TOP_UP = 'CARD_TOP_UP',
  CARD_WITHDRAW = 'CARD_WITHDRAW',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
}

export enum EEngineRunStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_BATCH = 'WAITING_FOR_BATCH',
  BATCH_IN_PROGRESS = 'BATCH_IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
